export enum FIELD_TYPE {
    COLOR_PICKER = 'COLOR_PICKER',
    SELECTOR = 'SELECTOR',
    TREE_SELECTOR = 'TREE_SELECTOR',
    TEXT = 'TEXT',
    PERIOD_SELECTOR = 'PERIOD_SELECTOR',
}
